enum SwapType {
  UNDEFINED_TYPE = 0,
  PAIR_SWAP = 1,
  DIRECT_SWAP = 2,
  PROXY_PAIR_SWAP = 3,
  PROXY_DIRECT_SWAP = 4,
}

export { SwapType };
